import { IconProps } from '.';

const ServiceIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142900)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.0051 3.4258C14.0217 -0.0965217 7.96216 -0.0492238 4.0318 3.6355C-0.247545 7.64738 -0.356514 14.4051 3.79125 18.5528L17.1212 31.8828C17.3556 32.1172 17.6736 32.2489 18.0051 32.2489C18.3366 32.2489 18.6546 32.1172 18.889 31.8828L32.219 18.5528C36.3667 14.4051 36.2578 7.64738 31.9784 3.6355C28.0481 -0.0492238 21.9886 -0.0965217 18.0051 3.4258ZM16.2177 5.1852C13.1929 2.6275 8.68232 2.70246 5.74165 5.45934C2.49263 8.50529 2.4099 13.6359 5.55902 16.7851L18.0051 29.2312L27.4873 19.7489L21.3384 13.6L18.889 16.0495C17.0201 17.9183 13.9901 17.9183 12.1212 16.0495C10.2524 14.1806 10.2524 11.1506 12.1212 9.28171L16.2177 5.1852ZM29.2551 17.9812L30.4512 16.7851C33.6003 13.636 33.5176 8.50529 30.2686 5.45934C27.1644 2.54919 22.311 2.62745 19.3023 5.63617L13.889 11.0495C12.9964 11.942 12.9964 13.3892 13.889 14.2817C14.7816 15.1743 16.2287 15.1743 17.1212 14.2817L20.4546 10.9484C20.9427 10.4602 21.7342 10.4602 22.2223 10.9484L29.2551 17.9812Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142900">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ServiceIcon;
